export default {
    "clipboard": {
        "success": "{data} copied to the clipboard",
        "error": "Clipboard error"
    }
};
